import * as firebase from "firebase/app";
import matcha_user from './../api/user'


/**
 * Handles the sign in button press.
 */
export function SignIn(email, password) {
    return new Promise((resolve, reject) => {
        // Sign in with email and pass.
        // [START authwithemail]
        firebase.auth().signInWithEmailAndPassword(email, password)
            .then(user => {
                resolve(user);
            })
            .catch(error => {
                reject(error);
            });
    })
}


/**
 * Handles the sign up button press.
 */
export function SignUp(email, password, addition_data) {
    return new Promise((resolve, reject) => {
        // Sign in with email and pass.
        // [START createwithemail]
        firebase.auth().createUserWithEmailAndPassword(email, password)
            .then(user => {

                if(user.additionalUserInfo.isNewUser){
                    // Save Data to MATCHA DB
                    let bodyParameters = {
                        email,
                        password,
                        language_id: addition_data.language_id,
                        newsletter: addition_data.newsletter,
                        firebase_uid: user.user.uid,
                        sns_registration: false,
                        user_nickname: addition_data.user_nickname
                    };

                    matcha_user.signup(bodyParameters)
                        .then(res => {

                            firebase.auth().currentUser.updateProfile({
                                displayName: addition_data.user_nickname,
                            })
                            .then((res) => {
                                firebase.auth().currentUser.sendEmailVerification().then(() => {
                                    resolve(user)
                                }).catch(err => {
                                    // console.log(err)
                                })    
                            })
                            .catch((error) => {
                                firebase.auth().currentUser.sendEmailVerification().then(() => {
                                    resolve(user)
                                }).catch(err => {
                                    // console.log(err)
                                })                                    
                            })
                        })
                        .catch(err => {
                            firebase.auth().onAuthStateChanged(user => {
                                if (!user) return;

                                user.delete().then(result => {
                                    reject(err.response);
                                    // console.log(result);
                                }).catch(error => {
                                    reject(error)
                                });
                            })
                        })
  
                }else{
                    // Check if has Matcha Id
                    firebase.auth().currentUser.sendEmailVerification().then(function () {
                        resolve(user)
                    });
                }
            })
            .catch(function (error) {
                // Handle Errors here.
                reject(error)
            });
        // [END createwithemail]        
    })
}






/**
 * Sends an email verification to the user.
 */
export function sendEmailVerification() {
    return new Promise((resolve, reject) => {
        // [START sendemailverification]
        firebase.auth().currentUser.sendEmailVerification().then(()=> {
            // Email Verification sent!
            resolve('Email Verification Sent!');
        });
    })
}




export function onIdTokenRevocation() {
    // For an email/password user. Prompt the user for the password again.
    let password = prompt('Please provide your password for reauthentication');
    let credential = firebase.auth.EmailAuthProvider.credential(
    firebase.auth().currentUser.email, password);
    
    firebase.auth().currentUser.reauthenticateWithCredential(credential)
        .then(result => {
            // User successfully reauthenticated. New ID tokens should be valid.
        })
        .catch(error => {
            // An error occurred.
        });
}



// WEBPACK FOOTER //
// ./src/auth/email-password.js